import Icon from 'vue-awesome/components/Icon'

Icon.register({
  first_page_rounded: {
    paths: [
      {
        d: 'M17.7 15.89L13.82 12l3.89-3.89A.996.996 0 1016.3 6.7l-4.59 4.59a.996.996 0 000 1.41l4.59 4.59c.39.39 1.02.39 1.41 0a.993.993 0 00-.01-1.4zM7 6c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1z'
      }
    ],
    width: '24',
    height: '24'
  }
})
